import { EmployeeLiteModel } from 'api-hooks/employee';
import { Expose, Type } from 'class-transformer';
import {
  BonusPeriodStatusEnum,
  CalculationTypeEnum,
  EmployeeGradeEnum,
  EmployeeJobLevelEnum,
  SaleDepartmentEnum,
} from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class BonusPeriodLiteModel extends CommonModel {
  @Expose({ name: 'issue_at' })
  @Type(() => Date)
  issueAt: Date;

  @Expose({ name: 'start_at' })
  @Type(() => Date)
  startAt: Date;

  @Expose({ name: 'end_at' })
  @Type(() => Date)
  endAt: Date;

  name: string;
  status: BonusPeriodStatusEnum;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class BonusPeriodEmployeeJobLevelConfigurationModel {
  id: string;

  @Type(() => Number)
  count: number;

  @Expose({ name: 'job_level' })
  jobLevel: EmployeeJobLevelEnum;

  @Type(() => Number)
  percentage: number;
}

export class BonusPeriodEmployeePerformanceConfigurationModel {
  id: string;

  @Type(() => Number)
  count: number;

  grade: EmployeeGradeEnum;

  @Type(() => Number)
  percentage: number;
}

export class BonusPeriodSaleConfigurationModel {
  id: string;
  department: SaleDepartmentEnum;
  type: CalculationTypeEnum;

  @Expose({ name: 'lead_bonus' })
  @Type(() => Number)
  leadBonus: number;

  @Expose({ name: 'operator_sales_bonus' })
  @Type(() => Number)
  operatorSalesBonus: number;
}

export class BonusPeriodEmployeeModel {
  id: string;
  grade: EmployeeGradeEnum;

  @Type(() => EmployeeLiteModel)
  employee: EmployeeLiteModel;

  @Expose({ name: 'job_level' })
  jobLevel: EmployeeJobLevelEnum;
}

export class BonusPeriodModel extends BonusPeriodLiteModel {
  @Expose({ name: 'bonus_period_employee_job_level_configurations' })
  @Type(() => BonusPeriodEmployeeJobLevelConfigurationModel)
  employeeJobLevelConfigurations: BonusPeriodEmployeeJobLevelConfigurationModel[];

  @Expose({ name: 'bonus_period_employee_performance_configurations' })
  @Type(() => BonusPeriodEmployeePerformanceConfigurationModel)
  employeePerformanceConfigurations: BonusPeriodEmployeePerformanceConfigurationModel[];

  @Expose({ name: 'bonus_period_sale_configurations' })
  @Type(() => BonusPeriodSaleConfigurationModel)
  saleConfigurations: BonusPeriodSaleConfigurationModel[];

  @Expose({ name: 'bonus_period_employees' })
  @Type(() => BonusPeriodEmployeeModel)
  employees: BonusPeriodEmployeeModel[];

  @Expose({ name: 'profit_percentage' })
  @Type(() => Number)
  profitPercentage: number;
}

export class PreviousBonusPeriodEmployeesModel {
  id: string;

  @Type(() => EmployeeLiteModel)
  employee: EmployeeLiteModel;

  @Expose({ name: 'job_level' })
  jobLevel: EmployeeJobLevelEnum;

  grade: EmployeeGradeEnum;
}

export type getBonusPeriodsInputFilter = {
  name?: string;
  status?: string;
};

export type getBonusPeriodsInput = {
  params: CommonParamInput<object, getBonusPeriodsInputFilter>;
};

export type getBonusPeriodInput = {
  id: string;
};

export type getPreviousBonusPeriodEmployeesInput = {
  params: CommonParamInput & {
    bonus_period_id: string;
  };
};

export type BonusPeriodSaleConfigurationMutationInput = {
  id?: string;
  department: string;
  type: string;
  operatorSalesBonus: number;
  leadBonus: number;
};

export type BonusPeriodEmployeePerformanceConfigurationMutationInput = {
  id?: string;
  grade: string;
  percentage: number;
};

export type BonusPeriodEmployeeJobLevelConfigurationMutationInput = {
  id?: string;
  jobLevel: string;
  percentage: number;
};

export type BonusPeriodEmployeeMutationInput = {
  id?: string;
  employeeId: string;
  jobLevel: string;
  grade: string;
};

export type BonusPeriodMutationInput = {
  name: string;
  startAt: Date | null;
  endAt: Date | null;
  issueAt: Date | null;
  profitPercentage: number;
  saleConfigurations: BonusPeriodSaleConfigurationMutationInput[];
  employeePerformanceConfigurations: BonusPeriodEmployeePerformanceConfigurationMutationInput[];
  employeeJobLevelConfigurations: BonusPeriodEmployeeJobLevelConfigurationMutationInput[];
  employees: BonusPeriodEmployeeMutationInput[];
};

export type BonusPeriodUpdateInput = {
  id: string;
  body: BonusPeriodMutationInput;
};

export type BonusPeriodDeleteInput = {
  id: string;
};
